"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSession = void 0;
const board_1 = require("@creature-chess/board");
const utils_1 = require("@creature-chess/utils");
const BattleSession_1 = require("./BattleSession");
class GameSession {
    constructor(settings) {
        this.settings = settings;
        this.board = new board_1.SubscribableBoard(settings.boardWidth, settings.boardHalfHeight);
        this.bench = new board_1.SubscribableBoard(settings.benchSize, 1);
        this.pieceRegistry = new utils_1.PieceRegistry();
        this.battle = new BattleSession_1.BattleSession(this.pieceRegistry, this.settings);
    }
}
exports.GameSession = GameSession;
